import { Getrequestcall } from "../../request/Getrequest";
import { USER_REWARD_AMOUNT } from "../../constant/Apipath";
import { setMenuCardBuilderBucks } from "../../redux/actions/actions";

export const getMenuCardBuilderBucks = (userId, token) => {
  return async (dispatch) => {
    try {
      const userRewardUrl = `${USER_REWARD_AMOUNT}/${userId}`;
      const userRewardRes = await Getrequestcall(userRewardUrl, token);
      const userRewardData = userRewardRes?.data?.data;
      let builderBucksData = {
        years: 0,
        companies: 0,
        bucks: userRewardData?.bucks
      };
      dispatch(setMenuCardBuilderBucks(builderBucksData));
    } catch (error) {
      console.log("getMenuCardBuilderBucks-> Error While Getting User Reward Amount: ", error);
      dispatch(
        setMenuCardBuilderBucks({
          sites: 0,
          years: 0,
          companies: 0,
          bucks: 0
        })
      );
    }
  };
};
